/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiAISessionPayloadFromJSON(json) {
    return ApiAISessionPayloadFromJSONTyped(json, false);
}
export function ApiAISessionPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'prompt': !exists(json, 'prompt') ? undefined : json['prompt'],
        'useMcpAgent': !exists(json, 'useMcpAgent') ? undefined : json['useMcpAgent'],
    };
}
export function ApiAISessionPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'prompt': value.prompt,
        'useMcpAgent': value.useMcpAgent,
    };
}
